










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice, GQL_newInvoiceData_newInvoice_orders_orderDelivery } from '@/queries/__generated__/newInvoiceData';
import { isEqual, assign } from 'lodash';

@Component
export default class InvoiceDeliveryPicker extends Vue {
  public assign = assign;

  @Prop(Object) public invoice!: GQL_newInvoiceData_newInvoice;

  private get uniqueDeliveries(): GQL_newInvoiceData_newInvoice_orders_orderDelivery[] {
    const arr: GQL_newInvoiceData_newInvoice_orders_orderDelivery[] = [];

    this.invoice.orders.forEach(order => {
      if (
        !arr.some(unique => isEqual(
          { ...order.orderDelivery, id: null },
          { ...unique, id: null },
        ))
      ) {
        arr.push(order.orderDelivery);
      }
    });

    return arr;
  }
}
